/* The Blue theme suits the Kohd Writer's tech look, so while that page is open
   (and another theme is on) the Blue swatch is drawn larger with a soft pulse. */
export const isSuggestedTheme = (id: string, current: string, pathname: string) =>
  id === 'blue' && current !== 'blue' && pathname.startsWith('/kohd');

/** The swatch name, with the recommendation added while it is suggested. */
export const themeLabel = (t: { id: string; label: string }, current: string, pathname: string) =>
  isSuggestedTheme(t.id, current, pathname) ? `${t.label} (recommended for Kohd Writer)` : t.label;
